import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import UploadError from "../Assets/UploadError.png";
import EyeIcon from '../Assets/Icons/eyeIcon.svg'

export default function AiProjectSuccessUploadError() {
  return (
    <DashboardLayout>
      <section className="w-full bg-[#F3F4F6] h-[91vh] px-6 pt-5">
        <div
          style={{
            boxShadow:
              " 0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)",
          }}
          className="w-full py-8 px-5 bg-white h-[85vh]"
        >
          <div className="flex items-center justify-center h-full">
            <div className="flex items-center flex-col justify-center gap-2 w-[40%]">
              <img className="w-[8rem] h-[7rem]" src={UploadError} />
              <p className="text-[1.2rem] text-[#111928] font-[600] mt-2">
                Oops!
              </p>
              <p className="text-[0.85rem] text-[#6B7280] font-[500] text-center">
                there are no AI Team Profiles that match your project request.
                Please populate your AI people ecosystem by inviting your
                colleagues and teams.
              </p>
              <button className="w-full h-[2.5rem] border-[1px] rounded-[8px] border-[#942A27] text-[0.95rem] text-[#942A27] font-[500] flex items-center justify-center gap-3 mt-1"><img src={EyeIcon} />View All AI Projects</button>
            </div>
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
